var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDj(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-dj",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M55.4 0H764v708.7H55.4z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)",
    transform: "translate(-40) scale(.722)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0c0",
    d: "M0 0h1063v708.7H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#69f",
    d: "M0 0h1063v354.3H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fffefe",
    d: "m0 0 529.7 353.9L0 707.3V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "m221.2 404.3-42.7-30.8-42.4 31 15.8-50.3-42.4-31.2 52.4-.4 16.3-50.2 16.6 50 52.4.2-42.1 31.4 16 50.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDj);
export default __webpack_public_path__ + "static/media/dj.36af2e47bbc2af2d377b7a74c3b7f1c0.svg";
export { ForwardRef as ReactComponent };